import { pairHasOpenIssue, useTaskActivitiesForServiceRequest } from '@commenda/api/tasks';
import { cn } from '@commenda/utils';
import { Country, TaskStatus } from '@prisma/client';
import { State } from 'country-state-city';
import { ServiceRequestTaskProps } from '../../../types';
import { ComplianceTaskDueDate } from '../../../utils';

type ServiceRequestTaskSalesTaxFilingCardPreviewProps = Omit<
  ServiceRequestTaskProps,
  'taskRole' | 'isTimelineView'
>;

function ServiceRequestTaskSalesTaxFilingCardPreview({
  task,
  config,
  state,
  context,
}: ServiceRequestTaskSalesTaxFilingCardPreviewProps) {
  const data = context.serviceRequest;

  const leftIcon = config.getLeftIcon(state.status);
  const stateConfig = config.getStateConfig(state);

  const { data: activityFeed } = useTaskActivitiesForServiceRequest(data?.id);
  const taskHasOpenIssue =
    task.status !== TaskStatus.COMPLETED &&
    pairHasOpenIssue(activityFeed?.activities, task);

  const isInProgress = state.status === TaskStatus.IN_PROGRESS;

  const disabled = state.status === TaskStatus.BACKLOG;

  const dueDate = (data?.metadata as { dueDate: string })?.dueDate;
  const jurisdictionStateCode = (data?.metadata as { state: string })?.state;

  const stateName = State.getStateByCodeAndCountry(
    jurisdictionStateCode,
    Country.US
  )?.name;

  return (
    <div
      className={cn(
        'flex justify-between items-center h-16 p-xl',
        disabled
          ? 'bg-bg-primary-hover cursor-not-allowed'
          : taskHasOpenIssue
            ? 'border-border-error'
            : ''
      )}
    >
      <div className="flex flex-col gap-xs txt-small-medium">
        <div
          className={cn(
            'flex gap-md items-center',
            isInProgress ? 'txt-small-medium text-text-primary' : '',
            disabled ? 'text-text-disabled' : ''
          )}
        >
          {stateConfig.label}
        </div>

        <div className="flex gap-md text-text-secondary txt-extra-small-regular mr-md">
          <span className="truncate">{stateName}</span>
          <span>•</span>
          <div className="shrink-0">
            <ComplianceTaskDueDate dueDate={dueDate} />
          </div>
        </div>
      </div>
      <div className="flex items-center gap-md">{stateConfig.actions}</div>
    </div>
  );
}

export { ServiceRequestTaskSalesTaxFilingCardPreview };
